import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Checkbox, ListItem } from 'material-ui';
import { updateSuppProfileProps } from '../../../stores/profile/company/profile-actions';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const ImportData = props => {
  const {
    updateProp,
    profileReducer,
    productType,
  } = props;
  const { idToImportTo: prodToFilter } = profileReducer;
  const prodItems = [{ text: 'Cover Image', db: 'coverImageUrl' },
    { text: 'Media', db: 'media' }];

  const accomProd = [{ text: 'Product Code', db: 'code' },
    { text: 'Description', db: 'short_desc' },
    { text: 'Amenities', db: 'amenities' },
    { text: 'Room Size', db: 'avg_room_size;room_size_units' },
    { text: 'Interconnection Rooms Availibility', db: 'interconnecting_rooms' },
    { text: 'Room Count', db: 'total_room_of_this_type' },
    { text: 'Bedding Configuration', db: 'rooms' }];

  const nonaccomProd = [{ text: 'Product Code', db: 'tour_code' },
    { text: 'Description', db: 'description' },
    { text: 'Tour Duration', db: 'tour_duration_unit;tour_duration' },
    { text: 'Standard Inclusions', db: 'standard_inclusion' },
    { text: 'Standard Exclusions', db: 'exclusion' },
    { text: 'What To Bring', db: 'what_to_bring' },
    { text: 'Max Passengers', db: 'total_max_pax' },
    { text: 'Min Passengers', db: 'total_min_pax' }];

  const filterOutProd = R.flatten((R.propOr([], 'locations', profileReducer))).reduce((acc, loc) => {
    if (R.propOr('', 'id', loc).toString() !== (prodToFilter || '').toString()) {
      loc.products.map(prod => {
        acc.push({
          locName: loc.name,
          prodName: prod.name,
          prodId: prod.id,
        });
      });
      return acc;
    }
  }, []);

  return (
    <div style={{ borderRadius: '3px', border: '1px solid grey' }}>
      {
        isNilOrEmpty(filterOutProd) ? <span style={{ padding: '5px', color: 'red' }}>You do not have any products to import from.</span> :
          filterOutProd.map((prod, i) => {
            const checkProdType = productType === 'Accommodation' ? prodItems.concat(accomProd) : prodItems.concat(nonaccomProd);
            return (
              <ListItem
                key={i}
                leftCheckbox={
                  <Checkbox
                    onCheck={R.ifElse(
                      () => R.equals(prod.prodId, R.pathOr([], ['itemToImport', 'prodId'], profileReducer)),
                        () => updateProp({ itemToImport: {}, prodId: null }),
                      () => updateProp({ itemToImport: { prodId: prod.prodId, itemsToImport: checkProdType } })
                    )}
                    checked={R.pathOr('', ['itemToImport', 'prodId'], profileReducer) === prod.prodId && R.pathOr(0, ['itemToImport', 'itemsToImport', 'length'], profileReducer) === checkProdType.length}
                  />
                }
                primaryText={
                  <span>
                    {prod.locName} - {prod.prodName} {R.pathOr('', ['itemToImport', 'prodId'], profileReducer) === prod.prodId ? ` - Importing ${R.pathOr('', ['itemToImport', 'itemsToImport', 'length'], profileReducer)} Items` : ''}
                  </span>
                }
                initiallyOpen={false}
                nestedItems={checkProdType.map((item, j) => {
                  const itemsToImport = R.pathOr([], ['itemToImport', 'itemsToImport'], profileReducer);
                  const isChecked = R.contains(item.text, itemsToImport.map(obj => obj.text));
                  return (
                    <ListItem
                      key={j}
                      primaryText={item.text}
                      leftCheckbox={
                        <Checkbox
                          onCheck={() => {
                            const currentObj = R.propOr({}, 'itemToImport', profileReducer);
                            const newItems = isChecked ? R.without([item], itemsToImport) : R.append(item, itemsToImport);
                            updateProp({ itemToImport: R.merge(currentObj, { itemsToImport: newItems, prodId: prod.prodId }) });
                          }}
                          checked={isChecked && R.pathOr('', ['itemToImport', 'prodId'], profileReducer) === prod.prodId}
                        />
                      }
                    />
                  );
                })}
              />
            );
          })
      }
    </div>
  );
};

ImportData.propTypes = {
  updateProp: PropTypes.func,
  profileReducer: PropTypes.object,
  productType: PropTypes.string,
  products: PropTypes.array,
};

const mapStateToProps = ({ profile, user }) => ({
  profileReducer: profile.toJS(),
  productType: user.getIn(['company', 'productType']),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateSuppProfileProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportData);



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/importProdData.jsx